var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLanding1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "landing1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h128v128H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#landing1_svg__a)",
  "data-name": "Group 102"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h128v128H0z",
  "data-name": "Rectangle 65"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 101"
}, /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10,
  strokeWidth: 2,
  "data-name": "Group 55",
  transform: "translate(29 29)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.055,
  cy: 16.055,
  r: 16.055,
  fill: "none",
  stroke: "#051526",
  "data-name": "Ellipse 9",
  transform: "translate(10.268)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#051526",
  d: "M47.506 64.573H6.204",
  "data-name": "Line 6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#051526",
  d: "M0 64.57a26.327 26.327 0 0 1 41.83-21.274",
  "data-name": "Path 76"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#0091ea",
  "data-name": "Group 54"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.799 49.029v-7.908l-13.925-7.495-13.925 7.495v7.908s-.8 16 13.925 20.17c14.724-4.167 13.925-20.17 13.925-20.17z",
  "data-name": "Path 77"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48.755 50.594 5.079 5.079 9.16-9.159",
  "data-name": "Path 78"
})))))));
export { SvgLanding1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggMTI4Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjxnIGRhdGEtbmFtZT0iR3JvdXAgMTAyIiBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDY1IiBmaWxsPSJub25lIiBkPSJNMCAwaDEyOHYxMjhIMHoiLz48ZyBkYXRhLW5hbWU9Ikdyb3VwIDEwMSI+PGcgZGF0YS1uYW1lPSJHcm91cCA1NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkgMjkpIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMiI+PGNpcmNsZSBkYXRhLW5hbWU9IkVsbGlwc2UgOSIgY3g9IjE2LjA1NSIgY3k9IjE2LjA1NSIgcj0iMTYuMDU1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4yNjgpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwNTE1MjYiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNiIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjMDUxNTI2IiBkPSJNNDcuNTA2IDY0LjU3M0g2LjIwNCIvPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCA3NiIgZD0iTTAgNjQuNTdhMjYuMzI3IDI2LjMyNyAwIDAxNDEuODMtMjEuMjc0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwNTE1MjYiLz48ZyBkYXRhLW5hbWU9Ikdyb3VwIDU0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDkxZWEiPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCA3NyIgZD0iTTY5Ljc5OSA0OS4wMjl2LTcuOTA4bC0xMy45MjUtNy40OTUtMTMuOTI1IDcuNDk1djcuOTA4cy0uOCAxNiAxMy45MjUgMjAuMTdjMTQuNzI0LTQuMTY3IDEzLjkyNS0yMC4xNyAxMy45MjUtMjAuMTd6Ii8+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDc4IiBkPSJNNDguNzU1IDUwLjU5NGw1LjA3OSA1LjA3OSA5LjE2LTkuMTU5Ii8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPgo=";